(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[159],{

/***/ 52709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ForgotPasswordPage; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_forgot_password_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44959);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1283);
/* harmony import */ var _components_buttons_return_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79303);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var __N_SSP = true;
function ForgotPasswordPage(props) {
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_7__.useTranslations)("title-pages");
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();

  var onClose = function onClose() {
    return router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.home */ .K.es.home);
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("title", null, titleT("forgot-password")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(props.url)),
    key: "canonical"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Center, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Content, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
    href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.signin */ .K.es.signin
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_buttons_return_button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, null))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_forgot_password_form__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    onClose: onClose
  }))));
}

var Center = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e19v1np81"
} : 0)( true ? {
  name: "4tsxew",
  styles: "display:grid;place-content:center;height:var(--main-height)"
} : 0);

var Content = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e19v1np80"
} : 0)( true ? {
  name: "b1xw50",
  styles: "background-color:white;max-width:600px;padding:30px 20px 70px 20px;margin:0 20px;border-radius:40px;box-shadow:0px 4px 12px rgba(0, 0, 0, 0.13)"
} : 0);

/***/ }),

/***/ 41196:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurar-clave",
      function () {
        return __webpack_require__(52709);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(41196); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);